import React, { CSSProperties } from 'react'
import ReactMarkdown from 'react-markdown'
import { ReactMarkdownAllowedElements } from 'helpers'
import parse from 'html-react-parser'

type Props = {
  content: string
  styles?: CSSProperties
  prefixContent?: string
  suffixContent?: string
}

const RichTextRender = ({ content, styles, prefixContent, suffixContent }: Props) => {
  // Check if the content starts with '<' to determine if it's HTML
  if (content?.trim().startsWith('<')) {
    // Parse HTML content
    return (
      <div
        style={{
          width: '150px',
          height: '64px',
          display: 'flex',
          verticalAlign: 'middle',
          // justifyContent: 'center',
          overflowX: 'clip',
          alignItems: 'center',
          alignSelf: 'center',
          ...styles,
        }}
      >
        {prefixContent ? prefixContent : ''}
        {parse(content)}
        {suffixContent ? suffixContent : ''}
      </div>
    )
  } else {
    // Parse Markdown content
    return (
      <div
        style={{
          width: '150px',
          height: '64px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          ...styles,
        }}
      >
        <ReactMarkdown
          allowedElements={ReactMarkdownAllowedElements}
          components={{
            p: ({ node, ...props }) => <p style={{ margin: '0' }} {...props} />,
            em: ({ node, ...props }) => <em style={{ margin: '0' }} {...props} />,
            strong: ({ node, ...props }) => <strong style={{ margin: '0' }} {...props} />,
            ol: ({ node, ...props }) => <ol style={{ margin: '0' }} {...props} />,
            ul: ({ node, ...props }) => <ul style={{ margin: '0' }} {...props} />,
            li: ({ node, ...props }) => <li style={{ margin: '0' }} {...props} />,
          }}
        >
          {/* {content.length < 30 ? content.substring(0, 30) : content.substring(0, 30).concat('...')} */}
          {`${prefixContent ? prefixContent : ''}${content} ${suffixContent ? suffixContent : ''}`}
        </ReactMarkdown>
      </div>
    )
  }
}

export default RichTextRender
